// @types
import { AutoRenewFormValues } from 'modules/common/types'
// @libraries
import * as Yup from 'yup'
import creditCardType from 'credit-card-type'

const accptCards = ['visa', 'mastercard', 'american-express', 'discover']

const orderNumber = Yup.string().required('')

const orderLineNumber = Yup.string().required('')

const name = Yup.string().required('Full name is required!')

const cardType = Yup.string()
  .required('Card type is required!')
  .test(
    'test-credit-card-type',
    'Credit card type is not currently accepted',
    (cardType) => {
      if (cardType) {
        return accptCards.some((card) => card === cardType)
      }

      return true
    },
  )

const cardNumber = Yup.string()
  .matches(/^[0-9]*$/, 'Not a valid number.')
  .required('Card number is required!')
  .test(
    'test-credit-card-number-type',
    'Credit card type is not currently accepted',
    (cardNumber) => {
      /**
       * @todo FOR TESTING ONLY, put behind env variable logic for example
       */
      if (cardNumber === '4111111111111111') return true

      if (cardNumber) {
        return accptCards.some(
          (card) => card === creditCardType(cardNumber)[0].type,
        )
      }

      return true
    },
  )
  .test(
    'test-credit-card-number-length',
    'Credit card number is not a valid format',
    (cardNumber) => {
      if (!cardNumber) return false

      /**
       * @todo FOR TESTING ONLY, put behind env variable logic for example
       */
      if (cardNumber === '4111111111111111') return true

      if (Array.isArray(creditCardType(cardNumber)[0].lengths)) {
        return creditCardType(cardNumber)[0].lengths.some((length: number) => {
          return length === cardNumber.length
        })
      }

      return true
    },
  )

const cardExpirationDate = Yup.string()
  .matches(/([0-9]{2})\/([0-9]{2})/, 'Not a valid date. Example: MM/YY')
  .test(
    'test-credit-card-expiration-date',
    'Date has expired',
    (expirationDate) => {
      if (!expirationDate) return false

      const today = new Date()
      const monthToday = today.getMonth() + 1
      // eslint-disable-next-line newline-per-chained-call
      const yearToday = today.getFullYear().toString().substr(-2)
      const [expMonth, expYear] = expirationDate.split('/')

      if (Number(expYear) < Number(yearToday)) {
        return false
      } else if (
        Number(expMonth) < monthToday &&
        Number(expYear) <= Number(yearToday)
      ) {
        return false
      }
      return true
    },
  )
  .test(
    'test-credit-card-expiration-date',
    'Invalid Month',
    (expirationDate) => {
      if (!expirationDate) return false
      const [expMonth] = expirationDate.split('/')
      return Number(expMonth) <= 12
    },
  )
  .required('Date is required')

const cardSecurityCode = Yup.string()
  .test(
    'test-credit-card-security-code',
    'Invalid Code',
    function (securityCode) {
      if (!securityCode) return false
      const parent = this.parent as AutoRenewFormValues
      return !(
        parent.cardNumber &&
        parent.cardNumber !== '' &&
        creditCardType(parent.cardNumber)[0].code.size !== securityCode.length
      )
    },
  )
  .required('Code is required!')

const agreeTerms = Yup.boolean()
  .required('Please read and agree to terms')
  .oneOf([true], 'The terms and conditions must be accepted.')

export const validationSchema = Yup.object().shape({
  orderNumber,
  orderLineNumber,
  name,
  cardType,
  cardNumber,
  cardExpirationDate,
  cardSecurityCode,
  agreeTerms,
})
